(function(){
  var AJAX_HEADERS = {
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  };

  async function emptyCart(){
    var r = await fetch('/cart.js', { headers: AJAX_HEADERS });
    if (!r.ok) return;
    var cart = await r.json();
    if (!cart.items || cart.items.length === 0) return;
    var body = new URLSearchParams();
    cart.items.forEach(function(it){
      body.append('updates[' + it.key + ']', '0');
    });
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: Object.assign({ 'Content-Type': 'application/x-www-form-urlencoded' }, AJAX_HEADERS),
      body: body.toString()
    });
  }

  async function addVariant(id){
    var body = new URLSearchParams();
    body.append('id', String(id));
    body.append('quantity', '1');
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: Object.assign({ 'Content-Type': 'application/x-www-form-urlencoded' }, AJAX_HEADERS),
      body: body.toString()
    });
    var data = await res.json().catch(function(){ return {}; });
    if (!res.ok) {
      console.error('[Reserve] add failed', res.status, data);
      throw new Error(data.description || data.message || ('HTTP ' + res.status));
    }
    return data;
  }

  function handle(btn){
    if (btn.__kbpBound) return;
    btn.__kbpBound = true;
    btn.addEventListener('click', async function(e){
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id');
      if (!id || id === '' || id === 'null') {
        alert('This kitten has no variant configured. Please contact us.');
        return;
      }

      // Open the new tab IMMEDIATELY (inside the click handler) so popup blockers don't kill it.
      var newTab = window.open('about:blank', '_blank');

      btn.disabled = true;
      var original = btn.textContent;
      btn.textContent = 'Processing…';
      try {
        await emptyCart();
        await addVariant(id);
        if (newTab && !newTab.closed) {
          newTab.location.href = '/checkout';
        } else {
          // popup blocked — fall back to same-tab redirect
          window.location.href = '/checkout';
        }
      } catch(err) {
        if (newTab && !newTab.closed) newTab.close();
        alert('Sorry: ' + (err.message || 'something went wrong.'));
        console.error('[Reserve]', err);
      } finally {
        btn.disabled = false;
        btn.textContent = original;
      }
    });
  }

  function bindAll(){
    document.querySelectorAll('[data-kbp-reserve-btn]').forEach(handle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('[data-kbp-reserve-btn]');
    if (btn) handle(btn);
  }, true);
})();
